export default __webpack_public_path__ + "df3231109001e423e9c73d7f3cf8aeee.png";